import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, normalizeClass as _normalizeClass, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-2308eb11"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "srs-wrap" }
const _hoisted_2 = { class: "srs-items" }
const _hoisted_3 = { class: "srs-item-wrap" }
const _hoisted_4 = ["onClick"]
const _hoisted_5 = { class: "fi-label-main" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "srs-item-wrap"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_FiLabelSub = _resolveComponent("FiLabelSub")!
  const _component_BoardSelectorPopup = _resolveComponent("BoardSelectorPopup")!
  const _component_StockRangeFactorItem = _resolveComponent("StockRangeFactorItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.rangeTree, (group, gi) => {
      return (_openBlock(), _createElementBlock("div", {
        key: group.attrCode,
        class: "srs-group"
      }, [
        _createElementVNode("div", {
          class: "srs-group-title",
          style: _normalizeStyle({ color: _ctx.colors.textMuted })
        }, _toDisplayString(gi + 1) + "." + _toDisplayString(group.attrName), 5),
        _createElementVNode("div", _hoisted_2, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.childAttrList, (item) => {
            return (_openBlock(), _createElementBlock(_Fragment, {
              key: item.attrCode
            }, [
              (_ctx.isBoardItem(item))
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createElementVNode("div", _hoisted_3, [
                      _createElementVNode("div", {
                        class: _normalizeClass(["factor-item", { selected: _ctx.boardSelected[item.attrCode]?.length > 0 }]),
                        style: _normalizeStyle(_ctx.tagStyle(_ctx.boardSelected[item.attrCode]?.length > 0)),
                        onClick: ($event: any) => (_ctx.openBoard(item))
                      }, [
                        _createElementVNode("span", _hoisted_5, _toDisplayString(item.attrName), 1),
                        (_ctx.boardSelected[item.attrCode]?.length)
                          ? (_openBlock(), _createBlock(_component_FiLabelSub, {
                              key: 0,
                              text: `已选择${_ctx.boardSelected[item.attrCode].length}个${item.attrName}`,
                              color: _ctx.colors.textMuted,
                              "max-width": "140px"
                            }, null, 8, ["text", "color"]))
                          : _createCommentVNode("", true),
                        (_ctx.boardSelected[item.attrCode]?.length)
                          ? (_openBlock(), _createElementBlock("span", {
                              key: 1,
                              class: "fi-remove",
                              onClick: _withModifiers(($event: any) => (_ctx.clearBoard(item.attrCode)), ["stop"])
                            }, "×", 8, _hoisted_6))
                          : _createCommentVNode("", true)
                      ], 14, _hoisted_4)
                    ]),
                    _createVNode(_component_BoardSelectorPopup, {
                      visible: _ctx.boardPopup.itemCode === item.attrCode,
                      title: item.attrName,
                      options: _ctx.boardPopup.options,
                      loading: _ctx.boardPopup.loading,
                      "initial-selected": _ctx.boardSelected[item.attrCode] || [],
                      "is-light": _ctx.isLight,
                      colors: _ctx.colors,
                      onConfirm: ($event: any) => (_ctx.onBoardConfirm(item.attrCode, $event)),
                      onCancel: _cache[0] || (_cache[0] = ($event: any) => (_ctx.boardPopup.itemCode = ''))
                    }, null, 8, ["visible", "title", "options", "loading", "initial-selected", "is-light", "colors", "onConfirm"])
                  ], 64))
                : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                    _createVNode(_component_StockRangeFactorItem, {
                      factor: _ctx.normalizeItem(item),
                      selected: _ctx.isItemSelected(item),
                      "is-light": _ctx.isLight,
                      colors: _ctx.colors,
                      headers: _ctx.headers,
                      "sub-label": _ctx.getSelectedHint(item),
                      "show-sub-label": true,
                      onToggle: _ctx.onToggle
                    }, null, 8, ["factor", "selected", "is-light", "colors", "headers", "sub-label", "onToggle"])
                  ]))
            ], 64))
          }), 128))
        ])
      ]))
    }), 128))
  ]))
}